import { AfterViewInit, Component, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { ModalService } from '@app/shared/services/modal/modal.service';
import { ErrorSummaryComponent } from '../error-summary/error-summary.component';
import { IdentificationService } from '../shared/identification.service';
import { ViewModelService } from '../shared/view-model.service';

@Component({
   selector: 'app-stepone',
   standalone: true,
   imports: [FormsModule, ModalComponent, ErrorSummaryComponent],
   templateUrl: './stepone.component.html',
   styleUrl: './stepone.component.scss',
})
export class SteponeComponent implements AfterViewInit {
   disableSubmit = false;

   @ViewChild('informationModal') informationModal?: ModalComponent;
   @ViewChild('tenancyReferenceModal') tenancyReferenceModal?: ModalComponent;

   public vm = inject(ViewModelService);
   public modalService = inject(ModalService);
   private idvService = inject(IdentificationService);
   private router = inject(Router);

   ngAfterViewInit(): void {
      console.log('Step One Component Initialized');
      setTimeout(() => {
         if (this.vm.isReady) {
            this.showInformationMessage();
         } else {
            this.vm.contentLoaded.subscribe((x) => {
               this.showInformationMessage();
            });
         }
      });
   }

   showInformationMessage(): void {
      if (this.vm.content && this.vm.content.step1InformationMessageBody !== '') {
         this.modalService.open('informationMessageModal', {
            backdrop: 'static',
            keyboard: false,
         });
      }
   }

   showTenancyReferenceInfo(): void {
      this.modalService.open('tenancyReferenceQuestionModal', {
         backdrop: true,
         keyboard: true,
      });
   }

   public findTenancy(): void {
      // Google Analytics tracking (if available)
      if ((window as any).ga) {
         (window as any).ga('send', 'event', {
            eventCategory: 'ID&V',
            eventLabel: 'Step One',
            eventAction: 'Find Address',
         });
      }

      this.disableSubmit = true;
      this.idvService.getTenancy().subscribe((t) => {
         if (t !== undefined) {
            this.vm.error = null;
            this.vm.tenancy = t;

            if (this.vm.tenancy.allowPortalRegistration) {
               if ((window as any).ga) {
                  (window as any).ga('send', 'event', {
                     eventCategory: 'ID&V',
                     eventLabel: 'Step One - Confirmation',
                     eventAction: 'Portal Registration - Allowed',
                  });
               }
               // Auto-navigate to stepone-confirm
               this.router.navigate(['stepone-confirm']);
            } else {
               if ((window as any).ga) {
                  (window as any).ga('send', 'event', {
                     eventCategory: 'ID&V',
                     eventLabel: 'Step One - Confirmation',
                     eventAction: 'Portal Registration - Not Allowed - Out of Scope',
                  });
               }
               if (this.vm.content) {
                  this.idvService.error(
                     this.vm.content.step1PropertyNotFoundTitle,
                     this.vm.content.step1PropertyNotFoundBody
                  );
               }
            }
         }
         this.disableSubmit = false;
      });
   }

   public formComplete(): boolean {
      return !!(this.vm.tenancyReference && this.vm.postcode);
   }

   formatPostcodeInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      let value = input.value;

      // Just uppercase - no trimming or space manipulation during typing
      value = value.toUpperCase();

      // Update the model value
      this.vm.postcode = value;
   }

   formatPostcodeBlur(event: Event): void {
      const input = event.target as HTMLInputElement;
      let value = input.value;

      // Uppercase the value
      value = value.toUpperCase();

      // Trim spaces from both ends
      value = value.trim();

      // Replace multiple spaces with a single space
      value = value.replace(/\s+/g, ' ');

      // If no space and at least 5 characters, insert space before last 3 characters
      if (value.length >= 5 && !value.includes(' ')) {
         value = value.slice(0, -3) + ' ' + value.slice(-3);
      }

      // Update the model value
      this.vm.postcode = value;
   }
}
